var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('resource-loader-controller',{attrs:{"resource":_vm.resource},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var receive = ref.receive;
var loading = ref.loading;
var result = ref.result;
return [_c('delayed-executor-controller',{attrs:{"delay":300,"receiver":receive},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var delayedReceive = ref.receive;
return [_c('view-component',_vm._b({attrs:{"value":_vm.value,"filter":_vm.filter,"result":result,"loading":loading,"receive":delayedReceive,"rules":_vm.rules,"initial-receive":_vm.initialReceive,"emit-full-value":_vm.emitFullValue},on:{"input":_vm.submit}},'view-component',_vm.$attrs,false))]}}],null,true)})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }